// @flow
import ImagePrepare from './ImagePrepare';
import type { ImageParamsType } from './ImagePrepare';

export default ImagePrepare;
export type { ImageParamsType };
